import { CURRENT_BASE, CURRENT_ZONE, zoneUrl } from "../constants/bookingBase";

const AGENCIES_ITINERARY_BASE = "/agencies";

export type PostCommitUserZone = {
  isStaff?: boolean;
  isMember?: boolean;
  isAgency?: boolean;
};

export function getBookingOrigin(isStaff = false, isMember = false, isAgency = false): string {
  if (process.env.NODE_ENV === "production") {
    if (isAgency) {
      return process.env.NEXT_PUBLIC_AGENCIES_APP_URL || process.env.BASE_URL || "";
    }
    if (isMember) {
      return process.env.NEXT_PUBLIC_MEMBER_APP_URL || process.env.BASE_URL || "";
    }
    if (isStaff) {
      return process.env.NEXT_PUBLIC_STAFF_APP_URL || process.env.BASE_URL || "";
    }
    return process.env.BASE_URL || "";
  }

  if (isStaff) {
    return "http://localhost:3001";
  }

  if (isAgency) {
    return process.env.NEXT_PUBLIC_AGENCIES_APP_URL || "http://localhost:3003";
  }

  if (isMember) {
    return process.env.NEXT_PUBLIC_MEMBER_APP_URL || "http://localhost:3004";
  }

  return "http://localhost:3002";
}

export function resolvePostCommitPath(postCommitPath: string, user: PostCommitUserZone): string {
  if (user.isStaff) return zoneUrl("staff", "/post-commit");
  if (user.isAgency) return "/agencies/booking/post-commit";
  if (user.isMember) return zoneUrl("member", "/post-commit");
  return postCommitPath || zoneUrl("booking", "/post-commit");
}

function resolveItineraryPath(path: string, user: PostCommitUserZone): string {
  if (user.isAgency) return `${AGENCIES_ITINERARY_BASE}${path}`;
  if (user.isStaff) return zoneUrl("staff", path);
  if (user.isMember) return zoneUrl("member", path);
  return zoneUrl("booking", path);
}
export function resolveItineraryUrl(rest = "/itinerary", user?: PostCommitUserZone): string {
  const path = rest.startsWith("/") ? rest : `/${rest}`;
  const hasZoneRole = Boolean(user?.isStaff || user?.isMember || user?.isAgency);

  if (!hasZoneRole && CURRENT_ZONE) return `${CURRENT_BASE}${path}`;

  return buildPostCommitNavigationUrl(resolveItineraryPath(path, user ?? {}), user ?? {});
}

export function buildPostCommitNavigationUrl(
  relativeCallbackUrl: string,
  user: PostCommitUserZone,
): string {
  const origin = getBookingOrigin(!!user.isStaff, !!user.isMember, !!user.isAgency).replace(
    /\/$/,
    "",
  );
  const path = relativeCallbackUrl.startsWith("/")
    ? relativeCallbackUrl
    : `/${relativeCallbackUrl}`;
  return `${origin}${path}`;
}
